/**
 * @generated SignedSource<<924efaa34200d92149e2fde982e8f41f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactPointSystemCodeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contactPointUseCodeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveFrom"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectiveTo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "contactPointSystemCodeId",
        "variableName": "contactPointSystemCodeId"
      },
      {
        "kind": "Variable",
        "name": "contactPointUseCodeId",
        "variableName": "contactPointUseCodeId"
      },
      {
        "kind": "Variable",
        "name": "effectiveFrom",
        "variableName": "effectiveFrom"
      },
      {
        "kind": "Variable",
        "name": "effectiveTo",
        "variableName": "effectiveTo"
      },
      {
        "kind": "Variable",
        "name": "locationContactPointId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "value",
        "variableName": "value"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "display",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditLocationContactPointModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationMutationGroup",
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "LocationContactPointModifyPayload",
            "kind": "LinkedField",
            "name": "modifyContactPoint",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LocationContactPoint",
                "kind": "LinkedField",
                "name": "locationContactPoint",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Location",
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationContactPoint",
                        "kind": "LinkedField",
                        "name": "contactPoints",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "LocationContactPoints_ContactPoints"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditLocationContactPointModalMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LocationMutationGroup",
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "LocationContactPointModifyPayload",
            "kind": "LinkedField",
            "name": "modifyContactPoint",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LocationContactPoint",
                "kind": "LinkedField",
                "name": "locationContactPoint",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Location",
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocationContactPoint",
                        "kind": "LinkedField",
                        "name": "contactPoints",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContactPointSystemCode",
                            "kind": "LinkedField",
                            "name": "contactPointSystemCode",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContactPointUseCode",
                            "kind": "LinkedField",
                            "name": "contactPointUseCode",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveFrom",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTo",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61f97384d6ebcd6723805a2ad32fee04",
    "id": null,
    "metadata": {},
    "name": "EditLocationContactPointModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditLocationContactPointModalMutation(\n  $id: ID!\n  $contactPointSystemCodeId: ID!\n  $contactPointUseCodeId: ID!\n  $value: String!\n  $effectiveFrom: DateOnly!\n  $effectiveTo: DateOnly!\n) {\n  location {\n    modifyContactPoint(input: {locationContactPointId: $id, contactPointSystemCodeId: $contactPointSystemCodeId, contactPointUseCodeId: $contactPointUseCodeId, value: $value, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {\n      locationContactPoint {\n        id\n        location {\n          contactPoints {\n            ...LocationContactPoints_ContactPoints\n            id\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment LocationContactPoints_ContactPoints on LocationContactPoint {\n  id\n  contactPointSystemCode {\n    id\n    display\n  }\n  contactPointUseCode {\n    id\n    display\n  }\n  value\n  effectiveFrom\n  effectiveTo\n}\n"
  }
};
})();

node.hash = "b3e6362451b681dcf4c487fe708d9e15";

export default node;
